var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.796 26.966v-9.42H8.405v-3.893h3.391v-3.14c0-3.349 1.675-5.023 5.024-5.023 1.256 0 2.26.083 3.014.251v3.265h-1.758c-1.34 0-2.01.67-2.01 2.01v2.637h3.768l-.628 3.893h-3.391v9.42c6.473-.989 11.303-6.613 11.303-13.16 0-7.303-6.009-13.313-13.312-13.313C6.503.493.493 6.503.493 13.806c0 6.547 4.831 12.171 11.303 13.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6d2fe2837a8ce697b0c98ecc375e0d2d.svg";
export { ForwardRef as ReactComponent };